import { coerceToNonEmpty } from '../../typeguards/index.js';
import { isCommerceItemIdentifierSet } from './commerceDataTypes.js';
export function isCommerceApiV1Auth(subject) {
    const pair = coerceToNonEmpty(subject);
    if (pair === false) {
        return false;
    }
    if (typeof pair.authKey !== 'string' ||
        typeof pair.siteId !== 'string' ||
        !pair.authKey ||
        !pair.siteId) {
        return false;
    }
    return true;
}
export function isCommerceSearchRequest(subject) {
    const search = coerceToNonEmpty(subject);
    if (search === false || !('searchTerms' in search)) {
        return false;
    }
    if ('linkTag' in search && typeof search.linkTag !== 'string') {
        return false;
    }
    return true;
}
export function isCommerceDiscoverRequest(subject) {
    const request = coerceToNonEmpty(subject);
    if (request === false || !('url' in request)) {
        return false;
    }
    return true;
}
export function isCommerceItemsDetailsRequest(subject) {
    const request = coerceToNonEmpty(subject);
    if (request === false || !('items' in request)) {
        return false;
    }
    if (!(request.items instanceof Array)) {
        return false;
    }
    for (const item of request.items) {
        if (!isCommerceItemIdentifierSet(item)) {
            return false;
        }
    }
    return true;
}
export function isCommerceAccountLinkTagRequest(subject) {
    const request = coerceToNonEmpty(subject);
    if (request === false || !('siteId' in request && 'vendor' in request)) {
        return false;
    }
    return true;
}
//# sourceMappingURL=commerceRequestTypes.js.map